import React from 'react';
import InventoryPage from '../InventoryPage';

const InventoryRegisterPage: React.FC = () => {
  return <InventoryPage />;
};

export default InventoryRegisterPage;
